<div class="modal-header">
  <h4 class="modal-title">
    <span i18n="@@planExpirationTitle">Plan Expiration Notice</span>
  </h4>
  <button type="button" class="close" aria-label="Close" (click)="onCancelClick()">
      <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div *ngIf="problem === 'expired' || problem === 'long-expired'" i18n="@@planExpired">Your plan has expired as we have not found your last payment. Please access more details in our payment center by clicking the button below.</div>
  <div *ngIf="problem === 'will-expire'" i18n="@@planWillExpire">Your plan will expire tomorrow and soon your contacts will no longer receive the deliveries of your tasks. Consider making a payment soon to avoid the suspension of the deliveries of your tasks. If you have made a payment recently, please disregard this message.</div>
  <div class="actions action-group button-group">
    <button
      role="button"
      type="button"
      class="btn btn-info btn-close"
      (click)="onCancelClick()"
      i18n="generic button label to cancel or close|A generic button label to close or cancel a form without saving nor submitting the changes@@genericCloseButton"
    >Close</button>
    <button
      type="button"
      class="btn btn-primary"
      (click)="onActionClick()"
      i18n="@@goToBillingButtonLabel"
    >Navigate to Billing</button>
  </div>
</div>
